export default "__VITE_ASSET__0c68003a__"